import React, { CSSProperties } from 'react';

import { useAppSelector } from 'state/hooks';

import { selectMaximize, selectSegmentId } from '../../state/workflowSlice';
import { ClosePanelButton } from './ClosePanelButton';
import { MaximizeButton } from './MaximizeButton';
import { workflowStyles } from './workspaceUtils';

import styles from './Workspace.module.css';

interface IBasePanel extends React.PropsWithChildren {
  sx?: CSSProperties;
  maximizeBtn?: boolean;
  closeBtn?: boolean;
}
export function BaseNoSegmentSelectedPanel({
  children,
  sx,
  maximizeBtn = true,
  closeBtn = false,
}: IBasePanel) {
  return (
    <BasePanel sx={sx} maximizeBtn={maximizeBtn} closeBtn={closeBtn}>
      <div className={styles.no_segment_message}>{children}</div>
    </BasePanel>
  );
}

export function BasePanel({
  children,
  sx,
  maximizeBtn = true,
  closeBtn = false,
}: IBasePanel) {
  const maximize = useAppSelector(selectMaximize);
  const { data_viz_style, header_style } = workflowStyles(maximize);

  return (
    <div className={data_viz_style} style={sx}>
      <div className={header_style}>
        <div className={styles.chart_header_right}>
          {maximizeBtn && <MaximizeButton />}
          {closeBtn && <ClosePanelButton />}
        </div>
      </div>
      {children}
    </div>
  );
}

export function NoSegmentSelectedPanel() {
  const segmentId = useAppSelector(selectSegmentId);
  if (segmentId === undefined) {
    return (
      <BaseNoSegmentSelectedPanel>
        <p>Please select a segment to see the chart</p>
      </BaseNoSegmentSelectedPanel>
    );
  } else {
    return undefined;
  }
}
